import { Action, createReducer, Store } from 'ngrx-actions';
import * as UserActions from './user-actions';
import * as UserLoginActions from './login';
import { userInitialState, UserState } from './state';

@Store({ ...userInitialState })
export class UserReducers {
  KEY = 'user22';

  /* Login Reducers */
  @Action(UserLoginActions.ActionLoginFail)
  actionLoginFail(state: UserState, action: UserLoginActions.ActionLoginFail) {
    return {
      ...state,
      loading: false,
      error: true,
      errorMessage: action.message
    };
  }

  @Action(UserLoginActions.ActionTrySuccess)
  actionTrySuccess(
    state: UserState,
    action: UserLoginActions.ActionTrySuccess
  ) {
    return {
      ...state,
      loading: false,
      error: false,
      user: action.user
    };
  }

  @Action(UserLoginActions.ActionTryLogin)
  actionTryLogin(state: UserState) {
    return {
      ...state,
      loading: true,
      error: false,
      errorMessage: null
    };
  }

  /*  User */
  @Action(UserActions.ActionFetchUser)
  actionFetchUser(state: UserState) {
    return {
      ...state,
      loading: true
    };
  }

  @Action(UserActions.ActionSaveUser)
  actionSaveUser(state: UserState, action: UserActions.ActionSaveUser) {
    return {
      ...state,
      loading: false,
      user: action.payload,
      error: false
    };
  }

  @Action(UserActions.ActionPopulateReduxUser)
  actionPopulateReduxUser(
    state: UserState,
    action: UserActions.ActionPopulateReduxUser
  ) {
    return {
      ...state,
      user: action.payload,
      error: false
    };
  }


  @Action(UserActions.ActionTryFail)
  actionFetchFail(state: UserState, action: UserActions.ActionTryFail) {
    return {
      ...state,
      loading: false,
      error: false,
      errorMessage: { ...action.payload }
    };
  }

  @Action(UserLoginActions.ActionLogoutUser)
  actionLogoutuser(state: UserState) {
    state = userInitialState;
    return {
      ...state
    };
  }

  @Action(UserActions.ActionLoadUser)
  actionLoadUser(state: UserState) {
    return {
      ...state,
      loading: true
    };
  }
}

export const userReducer = createReducer(UserReducers);
